import { render, staticRenderFns } from "./ShoppingCart.vue?vue&type=template&id=72e3a228&"
import script from "./ShoppingCart.vue?vue&type=script&lang=ts&"
export * from "./ShoppingCart.vue?vue&type=script&lang=ts&"
import style0 from "./ShoppingCart.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports